export default "__VITE_ASSET__eufu0WF9__"